var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "admin---users",
    transform: "translate(-1329.000000, -961.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1338.87621,976.270251 C1337.88701,977.24325 1336.28196,977.24325 1335.29324,976.270251 L1329.7419,970.809815 C1328.7527,969.837286 1328.7527,968.258511 1329.7419,967.285983 C1330.73062,966.312984 1332.33567,966.312984 1333.32487,967.285983 L1336.63238,970.538859 C1336.88206,970.783987 1337.28739,970.783987 1337.53755,970.538859 L1346.49331,961.729749 C1347.48203,960.75675 1349.08709,960.75675 1350.07628,961.729749 C1350.55131,962.196995 1350.81818,962.830946 1350.81818,963.491665 C1350.81818,964.152383 1350.55131,964.786335 1350.07628,965.253581 L1338.87621,976.270251 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c37a68b8581a3a9eb4d85e39f6d36c92.svg";
export { ForwardRef as ReactComponent };